import {
  PAGE_LAYOUT_TYPE,
  PAGE_LAYOUT_TYPE_VALUE,
} from '@typings/pages/pageLayout.interface';
import { useMemo } from 'react';

export function useFilterLayoutType({
  docLayout,
  pageSetting,
  defaultLayout,
}: {
  docLayout: string;
  pageSetting: PAGE_LAYOUT_TYPE_VALUE[];
  defaultLayout: PAGE_LAYOUT_TYPE_VALUE;
}) {
  // useState + useEffect 패턴을 제거하고 렌더 중 즉시 파생값으로 계산.
  // 이전 패턴은 초기값이 defaultLayout으로 고정되어 첫 렌더 후 반드시
  // 실제 레이아웃으로 한 번 더 전환되는 깜빡임을 유발했음.
  const docType: PAGE_LAYOUT_TYPE_VALUE = pageSetting.includes(
    docLayout as PAGE_LAYOUT_TYPE_VALUE,
  )
    ? (docLayout as PAGE_LAYOUT_TYPE_VALUE)
    : defaultLayout;

  const pageLayoutMap = useMemo(
    () =>
      Object.values(PAGE_LAYOUT_TYPE).reduce(
        (acc, layout) => {
          if (pageSetting.includes(layout)) acc[layout] = true;
          return acc;
        },
        {} as Record<string, boolean>,
      ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [pageSetting.join(',')],
  );

  return [docType, pageLayoutMap] as const;
}
